import { DotMatrix } from '@clickguard/design-system'

interface WaitingViewProps {
	onCancel: () => void
}

export const WaitingView = ({ onCancel }: WaitingViewProps) => {
	return (
		<div className="flex flex-col items-center justify-center gap-4 py-8">
			<DotMatrix size="lg" />
			<p className="text-[16px] leading-[22px] text-t-checkbox-unactive">
				Waiting for connection...
			</p>
			<button
				onClick={onCancel}
				className="text-[14px] text-red-600 hover:text-red-700 underline"
			>
				Cancel
			</button>
		</div>
	)
}
